import React, { useEffect, useRef } from "react"

interface CopyDraftAlertProps {
  message?: string
}

export const CopyDraftAlert: React.FC<CopyDraftAlertProps> = ({
  message = "🔁 Cópia criada. Agora apenas salve o novo cadastro.",
}) => {
  const alertRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const alertElement = alertRef.current

    if (!alertElement) {
      return
    }

    let scrollableContainer: HTMLElement | null = alertElement.parentElement

    while (scrollableContainer) {
      const isScrollable = scrollableContainer.scrollHeight > scrollableContainer.clientHeight

      if (isScrollable) {
        break
      }

      scrollableContainer = scrollableContainer.parentElement
    }

    if (scrollableContainer) {
      scrollableContainer.scrollTo({ top: 0, behavior: "smooth" })

      return
    }

    alertElement.scrollIntoView({ behavior: "smooth", block: "start" })
  }, [])

  return (
    <div
      ref={alertRef}
      className="mx-2 mb-2 mt-2 rounded-lg border-2 border-amber-300 bg-gradient-to-r from-amber-50 via-amber-100 to-orange-50 px-3 py-2 text-sm font-black text-amber-900 shadow-sm"
    >
      {message}
    </div>
  )
}
